import React from "react";
import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6" data-testid={testid}>
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, tone = "blue", onClick, testid }) {
  const tones = {
    blue: "text-blue-700 bg-blue-50 dark:bg-blue-950/40",
    orange: "text-orange-700 bg-orange-50 dark:bg-orange-950/40",
    green: "text-emerald-700 bg-emerald-50 dark:bg-emerald-950/40",
    red: "text-red-700 bg-red-50 dark:bg-red-950/40",
    slate: "text-slate-700 bg-slate-100 dark:bg-slate-800",
  };
  return (
    <div
      onClick={onClick}
      data-testid={testid}
      className={`p-5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-800 flex items-start justify-between ${onClick ? "cursor-pointer hover:shadow-md transition-shadow" : ""}`}
    >
      <div>
        <div className="text-2xl font-head font-extrabold">{value}</div>
        <div className="text-xs text-slate-500 mt-1 font-medium">{label}</div>
      </div>
      {Icon && (
        <div className={`w-10 h-10 rounded-lg grid place-items-center ${tones[tone]}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
    </div>
  );
}

export function Loading({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-16 text-slate-500 gap-2" data-testid="loading">
      <Loader2 className="w-5 h-5 animate-spin" /> {label}
    </div>
  );
}

export function Empty({ title = "Nothing here yet", subtitle, action }) {
  return (
    <div className="text-center py-16 border border-dashed border-slate-300 dark:border-slate-700 rounded-xl" data-testid="empty-state">
      <p className="font-semibold text-slate-700 dark:text-slate-200">{title}</p>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export const STAGE_STYLES = {
  New: "border-blue-500 bg-blue-50 text-blue-800 dark:bg-blue-950/40 dark:text-blue-200",
  Contacting: "border-violet-500 bg-violet-50 text-violet-800 dark:bg-violet-950/40 dark:text-violet-200",
  Connected: "border-cyan-500 bg-cyan-50 text-cyan-800 dark:bg-cyan-950/40 dark:text-cyan-200",
  "Visit/Demo Booked": "border-amber-500 bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200",
  Attended: "border-emerald-500 bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200",
  "Admission Pending": "border-orange-500 bg-orange-50 text-orange-800 dark:bg-orange-950/40 dark:text-orange-200",
  Enrolled: "border-emerald-600 bg-emerald-100 text-emerald-900 dark:bg-emerald-950/60 dark:text-emerald-200",
  Nurture: "border-slate-400 bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
  Lost: "border-red-500 bg-red-50 text-red-800 dark:bg-red-950/40 dark:text-red-200",
  Invalid: "border-gray-400 bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300",
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
